import posthog from 'posthog-js';

import { useGlobalStore } from '../../stores/useGlobalStore';

import hubspot from './hubspot';
import segmentAnalytics from './segment';

const isProductionApp = process.env.IS_PRODUCTION_APP === 'true';
const isStagingApp = process.env.IS_STAGING_APP === 'true';

const enableAnalytics = isProductionApp || isStagingApp;

const identify = (trackingId: string, metadata: Record<string, unknown>) => {
  if (!enableAnalytics) {
    console.log('[Analytics - DEV] identify:', { trackingId, metadata });
    return;
  }
  segmentAnalytics.identify(trackingId, metadata);
  posthog.identify(trackingId, metadata);

  // Map user properties to HubSpot contact properties
  const hubspotProperties = {
    firstname: metadata?.name as string,
    lastname: metadata?.surname as string,
    company: metadata?.company as string,
    annual_carbon_credits: metadata?.credit_retirement_volume as string,
    user_category: metadata?.company_type as string,
    company_type: metadata?.company_type as string,
  };

  // Identify the user in HubSpot
  hubspot.identifyContact(trackingId, hubspotProperties);

  // Always create or update contact in HubSpot
  hubspot.createOrUpdateContact({
    email: trackingId,
    ...hubspotProperties,
  });
};

const page = (...args) => {
  if (!enableAnalytics) {
    console.log('[Analytics - DEV] page:', args);
    return;
  }
  segmentAnalytics.page(...args);
  // Track page view in HubSpot
  // const pageName = args[0] || window.location.pathname;
  // hubspot.trackPageView(pageName);
};

const group = (...args) => {
  if (!enableAnalytics) {
    console.log('[Analytics - DEV] group:', args);
    return;
  }
  segmentAnalytics.group(...args);
};

const track = (event: string, current_page: string, payload?: Record<string, unknown>) => {
  if (!enableAnalytics) {
    console.log('[Analytics - DEV] track:', { event, current_page, payload });
    return;
  }

  const userStateValues = useGlobalStore.getState().user;
  const theme = localStorage.getItem('joy-mode');

  const properties = {
    userid: userStateValues?.email,
    company: [userStateValues?.company],
    credit_retirement_volume: userStateValues?.credit_retirement_volume,
    company_type: userStateValues?.company_type,
    subscription_end_date: userStateValues?.subscription_end_date,
    compass_modules_access: userStateValues?.compass_modules_access,
    ratings_access_type: userStateValues?.ratings_access_type,
    user_type: userStateValues?.user_type,
    compass_access_type: userStateValues?.compass_access_type,
    action: event,
    current_page,
    page_url: window.location.pathname,
    background_color: `${theme}_mode`,
    ...payload,
  };

  segmentAnalytics.track(event, properties);
  // Track event in HubSpot
  // hubspot.trackEvent(event, properties);
};

export { identify, page, track, group };
